module.exports = __webpack_public_path__ + "img/AdobeStock-small.733ab72e.png";